import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_CLIENT_DETAILS: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientDetails'
);

export const SET_AGENTS: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetAgents'
);

export const FETCH_ROLES: string = typeCreatorV2(
  'ClientDetailsReducer',
  'FetchRoles'
);

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientsMiniProfiles'
);

export const SET_STATUS_LIST: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetStatusList'
);

export const SET_READINESS_LEVEL_LIST: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetReadinessLevelList'
);

export const UPDATE_STATUS: string = typeCreatorV2(
  'ClientDetailsReducer',
  'UpdateStatus'
);

export const UPDATE_DETAILS: string = typeCreatorV2(
  'ClientDetailsReducer',
  'UpdateDetails'
);
export const SET_CLIENT_DETAIL_NOTES: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientDetailNotes'
);
export const CLIENT_DETAIL_CREATE_NOTE: string = typeCreatorV2(
  'ClientDetailsReducer',
  'ClientDetailCreateNotes'
);
export const SET_CUSTOMER_TAG_LIST: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetCustomerTagList'
);
export const SET_SPECIFICATIONATTRIBUTE_LIST: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetSpecificationAttributeList'
);

export const SET_CLIENT_ATTRIBUTE_JOB_POSITION: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientAttributeJobPosition'
);

export const SET_CLIENT_ATTRIBUTE_INDUSTRY: string = typeCreatorV2(
  'ClientDetailsReducer',
  'setClientAttributeIndustry'
);
export const SET_CLIENT_ATTRIBUTE_FOUND_US_ON: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientAttributeFoundUsOn'
);
export const SET_CLIENT_ATTRIBUTE_COMPANY_NAME: string = typeCreatorV2(
  'ClientDetailsReducer',
  'SetClientAttributeCompanyName'
);
